$(function() {
   //グローバルメニューマウスオーバーアクション

	// $(window).on("load resize", function() {
		var winW = $(window).width();
		var devW = 991;

		if (winW <= devW) {
			//SP処理

				// $(".navbar-toggler").on("click", function () {
			$(document).on("click", ".navbar-toggler", function () {
				if ($(this).hasClass("collapsed")) {
				} else {
					$(".submenu").removeClass("active");
				}
			});

			$(document).on("click", ".nav-link", function () {

        if ($(this).data("href") == "javascript:void(0)") {
          if ($(this).next(".submenu").hasClass("active")) {
            $(this).next(".submenu").removeClass("active");
          } else {
            $(this).next(".submenu").addClass("active");
          }
        } else {
					location.href = $(this).data('href');
					$(".navbar-collapse").removeClass("show");
        }
      });


			// $(".nav-item.has-submenu").on("click", function () {
			// $(document).on("click", ".nav-item.has-submenu a", function () {
			// 	if ($(this).next(".submenu").hasClass("active")) {
			// 		$(this).next(".submenu").removeClass("active");
			// 	} else {
			// 		$(this).next(".submenu").addClass("active");
			// 	}
			//});

		} else {
			//PC処理
			$(document).on("click", ".nav-link", function () {
        if ($(this).data("href") == "javascript:void(0)") {
          if ($(this).next(".submenu").hasClass("active")) {
            $(this).next(".submenu").removeClass("active");
          } else {
            $(this).next(".submenu").addClass("active");
          }
        } else {
          location.href = $(this).data("href");
          $(".navbar-collapse").removeClass("show");
        }
			});


			$(".nav-item.has-submenu").on({
				mouseenter: function() {
					$(this)
						.find(".submenu")
						.addClass("active");
				},
				mouseleave: function() {
					$(this)
						.find(".submenu")
						.removeClass("active");
				}
			});
		}
	// });
});
